import { render } from "./EthiotelEnglishFAQs.vue?vue&type=template&id=2b89de7a&scoped=true"
import script from "./EthiotelEnglishFAQs.vue?vue&type=script&lang=js"
export * from "./EthiotelEnglishFAQs.vue?vue&type=script&lang=js"

import "./EthiotelEnglishFAQs.vue?vue&type=style&index=0&id=2b89de7a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b89de7a"]])

export default __exports__